import { createWebviewScreen } from 'shared/src/component';

/**
 * 상품 리뷰 화면(`/reviews/:goodsSno`, 내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart / OrderDetail 과 같다 — 범용 `WebViewScreen` 으로 열면
 * 목적지가 `url` params 문자열로 들어가 주소가 `/reviews/123` 으로 유지되지 않는다.
 * Navigator 에 `path` 로 등록해 주소를 유지한다.
 *
 * 경로·타이틀만 다른 웹뷰 화면이라 `createWebviewScreen`(shared) 팩토리로 만든다.
 * `goodsSno` 는 path 세그먼트로 채워지고, 나머지 파라미터는 웹뷰 URL 쿼리로 승계된다.
 */
export const GoodsReviewSnoScreen = createWebviewScreen({
  screen: 'GoodsReviewSno',
  title: '리뷰',
});
